<ng-container *ngIf="(mode === 'ADD' || (mode === 'UPDATE' && showData) || mode === 'REVIEW'); then address; else skeleton">
</ng-container>
<ng-template #address>
    <div *ngIf="(mode === 'ADD' || mode === 'UPDATE'); else review">
        <form [formGroup]="addressFrm">
            <div class="d-flex flex-wrap justify-content-start row">
                <div class="d-flex flex-column col-xl-6 col-md-6 col-sm-12">
                    <label for="" class="col-form-label">Address Line 1 <app-required-label></app-required-label>
          </label>
                    <input type="text" formControlName="addressLine1" class="form-control form-control-sm text-uppercase" [ngClass]="{'is-invalid': isControlInvalid(f.addressLine1)}" placeholder="Street Address" maxlength="35" title="Street Address">
                    <app-error [caption]="'Address Line 1'" [control]="f.addressLine1" [isSubmit]="isSubmit" class="invalid-feedback"></app-error>
                </div>
                <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                    <label for="" class="col-form-label">Address Line 2 </label>
                    <input type="text" formControlName="addressLine2" class="form-control form-control-sm text-uppercase" [ngClass]="{'is-invalid': isControlInvalid(f.addressLine2)}" placeholder="APT/SUITE NUMBER" maxlength="35" title="Secondary Address">
                    <app-error [caption]="'Address Line 2'" [control]="f.addressLine2" [isSubmit]="isSubmit" class="invalid-feedback"></app-error>
                </div>
                <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                    <label for="" class="col-form-label">City <app-required-label></app-required-label></label>
                    <input type="text" formControlName="city" class="form-control form-control-sm text-uppercase" [ngClass]="{'is-invalid': isControlInvalid(f.city)}" placeholder="City" maxlength="34" title="City">
                    <app-error [caption]="'City'" [control]="f.city" [isSubmit]="isSubmit" class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                    <label for="" class="col-form-label">State <app-required-label></app-required-label></label>
                    <app-select [options]="stateList" formControlName="state" [ngClass]="{'is-invalid': isControlInvalid(f.state)}" [isInvalid]="isControlInvalid(f.state)" [orderBy]="'DESCR'" (changeEvent)="stateChange()">
                    </app-select>
                    <app-error [caption]="'State'" [control]="f.state" [isSubmit]="isSubmit" class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                    <label for="" class="col-form-label">Zip <app-required-label></app-required-label></label>
                    <p-inputMask type="text" formControlName="zip" styleClass="form-control form-control-sm" [ngClass]="{'is-invalid': isControlInvalid(f.zip)}" mask="99999?-9999" title="5 digits Zip or hyphenated zip + 4 code">
                    </p-inputMask>
                    <app-error [caption]="'Zip'" [control]="f.zip" [isSubmit]="isSubmit" class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                    <label for="" class="col-form-label">County <app-required-label></app-required-label></label>
                    <app-select [options]="countyMuniList" [optionValue]="'countyCode'" [label]="'countyName'" formControlName="countyCode" [ngClass]="{'is-invalid': isControlInvalid(f.countyCode)}" [isInvalid]="isControlInvalid(f.countyCode)" [orderBy]="'UNKNOWN_AT_END'"
                        (changeEvent)="countyChange()">
                    </app-select>
                    <app-error [caption]="'County'" [control]="f.countyCode" [isSubmit]="isSubmit" class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                    <label for="" class="col-form-label">Municipality <app-required-label></app-required-label></label>
                    <app-select [options]="municipalityList" [optionValue]="'municipalityCode'" [label]="'municipalityName'" formControlName="municipalityCode" [ngClass]="{'is-invalid': isControlInvalid(f.municipalityCode)}" [isInvalid]="isControlInvalid(f.municipalityCode)"
                        [orderBy]="'UNKNOWN_AT_END'">
                    </app-select>
                    <app-error [caption]="'Municipality'" [control]="f.municipalityCode" [isSubmit]="isSubmit" class="invalid-feedback">
                    </app-error>
                </div>
            </div>
        </form>
    </div>
</ng-template>
<ng-template #review>
    <form [formGroup]="addressFrm">
        <div class="d-flex flex-wrap justify-content-start row">
            <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                <label for="" class="col-form-label">Address Line 1</label>
                <span class="text-uppercase">{{f.addressLine1.value}}</span>
            </div>
            <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                <label for="" class="col-form-label">Address Line 2 </label>
                <span class="text-uppercase">{{f.addressLine2.value}}</span>
            </div>
            <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                <label for="" class="col-form-label">City</label>
                <span class="text-uppercase">{{f.city.value}}</span>
            </div>
            <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                <label for="" class="col-form-label">State</label>
                <span>{{stateDescr}}</span>
            </div>
            <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                <label for="" class="col-form-label">Zip</label>
                <span>{{f.zip.value}}</span>
            </div>
            <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                <label for="" class="col-form-label">County</label>
                <span>{{countyDescr}}</span>
            </div>
            <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                <label for="" class="col-form-label">Municipality</label>
                <span>{{municipalityDescr}}</span>
            </div>
        </div>
    </form>
</ng-template>
<ng-template #skeleton>
    <div class="d-flex flex-wrap justify-content-start row">
        <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
            <label for="" class="col-form-label">Address Line 1 <app-required-label></app-required-label></label>
            <input type="text" class="empty form-control form-control-sm">
        </div>
        <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
            <label for="" class="col-form-label">Address Line 2 </label>
            <input type="text" class="empty form-control form-control-sm">
        </div>
        <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
            <label for="" class="col-form-label">City <app-required-label></app-required-label></label>
            <input type="text" class="empty form-control form-control-sm">
        </div>
        <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
            <label for="" class="col-form-label">State <app-required-label></app-required-label></label>
            <input type="text" class="empty form-control form-control-sm">
        </div>
        <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
            <label for="" class="col-form-label">Zip <app-required-label></app-required-label></label>
            <input type="text" class="empty form-control form-control-sm">
        </div>
        <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
            <label for="" class="col-form-label">County <app-required-label></app-required-label></label>
            <input type="text" class="empty form-control form-control-sm">
        </div>
        <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
            <label for="" class="col-form-label">Municipality <app-required-label></app-required-label></label>
            <input type="text" class="empty form-control form-control-sm">
        </div>
    </div>
</ng-template>
